import { AttachmentUpload } from "./attachment_upload";
addEventListener("trix-attachment-add", function (event) {
  var attachment = event.attachment,
    target = event.target;
  if (attachment.file) {
    var upload = new AttachmentUpload(attachment, target);
    upload.start();
  }
});